import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import styled from "styled-components";
import { Paragraph } from "../../../../lib/Font/styles";

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 2rem;
  margin-right: 2rem;
  margin-bottom: 1.5rem;
`;

interface StyledAccordionProps {
  imagePath: string;
}

export const StyledAccordion = styled(Accordion).attrs<StyledAccordionProps>((props) => ({
  style: {
    backgroundImage: `linear-gradient(
      rgba(0, 0, 0, 0.45), 
      rgba(0, 0, 0, 0.45)
    ), url(${props.imagePath})`,
    backgroundPosition: 'center 20%'
  },
}))<StyledAccordionProps>`
  width: 100%;
  color: #ffffff;
  box-shadow: none;
  border-radius: 1.5rem;
  overflow: hidden;
  background-color: #000;
  background-size: cover;
  background-repeat: no-repeat;

  &.Mui-expanded {
    transition: height 0.5s ease;
  }
`;

export const AccordionSummaryContatiner = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  flex-direction: column;
  gap: 1rem;
  margin-top: 2rem;
  margin-bottom: 2rem;
`;

export const StyledAccordionSummary = styled(AccordionSummary)`
  color: white !important;
  justify-content: center;
  align-items: center;
  text-wrap: wrap;
  .MuiAccordionSummary-content {
    justify-content: center;
    align-items: center;
  }
`;

export const StyledAccordionDetails = styled(AccordionDetails)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 20px;
`;

export const StyledParagraph = styled(Paragraph)`
  font-size: 1.25rem;
  font-weight: lighter;
  width: 30%;
  text-align: center;
  @media (max-width: 1050px) {
    width: 70%;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  display: flex;
  gap: 1rem;
`;